// Library Imports
import React from 'react'
// Component Imports
import PageBanner from '../../components/banner/PageBanner'
import NewListingForm from '../../components/form/NewListingForm'
import { NewListingFormProvider } from '../../contexts/NewListingFormContext'
import { useParams } from 'react-router-dom'

function SignUp() {
  const { id } = useParams();

  return (
    <div className='signup-page-container'>
      <PageBanner pageName='Sign Up' />
      <NewListingFormProvider startPlanOption={id}>
        <NewListingForm />
      </NewListingFormProvider>
    </div>
  )
}

export default SignUp